module.exports = __webpack_public_path__ + "static/media/haryana.8b4c9949.png";